<script setup>
import MedallionLevels from '@/components/MedallionLevels.vue';
import { Tippy } from 'vue-tippy';

const sizes = {
    sm: 'w-6 h-6',
    md: 'w-10 h-10',
    lg: 'w-20 h-20',
};

defineProps({
    levelsInfo: {
        type: Object,
        required: true,
    },
    size: {
        type: String,
        required: false,
        default: 'md',
        validator(value) {
            return ['sm', 'md', 'lg'].includes(value);
        },
    },
});
</script>

<template>
    <Tippy>
        <button>
            <MedallionLevels :class="sizes[size]" :levels-info="levelsInfo" />
        </button>
        <template #content>
            <div class="font-semibold">{{ levelsInfo.mode }}</div>
            <div class="mt-5">
                <div class="mt-3" v-for="level in levelsInfo.levels" :key="level.difficulty">
                    <div>{{ $tc('messages.levels', 1) }} {{ level.difficulty }}</div>
                    <div class="text-xs">{{ level.date_display }} ({{ level.date_ago }})</div>
                </div>
            </div>
            <div class="mt-5 mb-3 flex justify-center">
                <MedallionLevels class="w-20 h-20" :levels-info="levelsInfo" />
            </div>
        </template>
    </Tippy>
</template>
